<template>
    <el-dialog title="操作日志详情" append-to-body :before-close="close" show-close :close-on-click-modal="false" :visible.sync="actionDetailVisible" width="70%">
        <div class="detailBox">
        <el-form :model="actionDetailForm" size="mini" label-width="180px">
            <el-form-item label="日志编号：">
                <el-tag type="primary" size="mini">{{actionDetailForm.id}}</el-tag>
            </el-form-item>
            <el-form-item label="操作人：">
                <el-tag type="primary" size="mini">{{actionDetailForm.userName}}</el-tag>
            </el-form-item>
            <el-form-item label="操作域：">
                <el-tag type="primary" size="mini">{{actionFieldList[actionDetailForm.field].name}}</el-tag>
            </el-form-item>
            <el-form-item label="操作类型：">
                <el-tag type="primary" size="mini">{{actionTypeList[actionDetailForm.type].name}}</el-tag>
            </el-form-item>
            <el-form-item label="描述：">
                <el-tag type="primary" size="mini">{{actionDetailForm.description}}</el-tag>
            </el-form-item>
            <el-form-item label="接口名：">
                <el-input v-model="actionDetailForm.method" style="width:80%" placeholder="接口名" disabled size="mini"></el-input>
            </el-form-item>
            <el-form-item label="参数：">
                <div id="params" class="highLightDiv" v-highlight v-if="actionDetailForm.params!=null &&actionDetailForm.params!=''">
                    <pre><code >{{formatJson(actionDetailForm.params)}}</code></pre>
                </div>
                <el-tag size="mini" type="info" v-else>无</el-tag>
            </el-form-item>
            <el-form-item label="返回值：">
                <div id="returnVal" class="highLightDiv" v-highlight v-if="actionDetailForm.returnValue!=null&&actionDetailForm.returnValue!=''">
                    <pre><code>{{formatJson(actionDetailForm.returnValue) }}</code></pre>
                </div>
                <el-tag size="mini" type="info" v-else>无</el-tag>
            </el-form-item>
            <el-form-item label="操作时间：">
                <el-tag type="info" size="mini">{{actionDetailForm.createTime|dateformatAll('YYYY-MM-DD HH:mm:ss')}}</el-tag>
            </el-form-item>
        </el-form>
        </div>
    </el-dialog>
</template>
<script>
import actionFieldList from '@/data/actionFieldList'
import actionTypeList from '@/data/actionTypeList'
export default {
    name:'ActionDetail',
    props:{
        actionDetailVisible:{type:Boolean,default:false},
    },
    data(){
        return {
            actionFieldList,
            actionTypeList,
            actionDetailForm:{
                id:null,
                userName:"",
                field:0,
                type:0,
                description:"",
                method:"",
                params:"",
                returnValue:"",
                createTime:null,
            }
        }
    },
    mounted(){},
    methods:{
        formatJson(jsonStr){
            if(jsonStr!==null && jsonStr!==""){
                return JSON.stringify(JSON.parse(jsonStr),null,2)
            }
        },
        close(){
            this.actionDetailForm={
                id:null,
                userName:"",
                field:0,
                type:0,
                description:"",
                method:"",
                params:"",
                returnValue:"",
                createTime:null,
            }
            this.$emit('changeVisible',false)
        },
        getVal(form){
            this.actionDetailForm=form
        }
    },
}
</script>
<style scoped>
.detailBox{
    width: 95%;
    height: 680px;
    overflow: auto;
}
.highLightDiv{
    width: 90%;
    height: 350px;
    overflow: auto;
}
</style>